export default function(form, target) {
    var value = (target.type === 'checkbox') ? target.checked : target.value
    form[target.name] = value
    return form
}


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Forms/form.js